import { useLazyGetSurveysQuery, useCreateSurveyMutation, useDeleteSurveyMutation } from 'src/redux/Api/surveysApi'
import style from '../surveys.module.scss'
import { Link, useNavigate } from 'react-router'
import DeleteOutlineOutlined from '@mui/icons-material/DeleteOutlineOutlined'
import FinalAccept from 'src/Components/FinalAccept'
import { useEffect, useState } from 'react'
import { useGetClientsQuery } from 'src/redux/Api/clientsApi'
import BackBtn from 'src/Components/BackBtn'
import { IClientsSurvey } from 'src/utils/Interfaces/client.interface'
import List from 'src/Components/List'
import MoreActionsList from 'src/Components/moreActionsList'

const Surveys = () => {
  const [trigger, { data: surveys }] = useLazyGetSurveysQuery()
  const [createSurveyMutation] = useCreateSurveyMutation()
  const [deleteSurveyMutation] = useDeleteSurveyMutation()
  const [popupConfirm, setPopupConfirm] = useState(false)
  const [deleteId, setDeleteId] = useState<number | null>(null)
  const navigate = useNavigate()
  const [folder, setFolder] = useState(null as number | null)
  const { data: clientsData } = useGetClientsQuery('withSurveys=true') as { data: IClientsSurvey[] }

  const createSurvey = async () => {
    if (!folder) return
    const survey = await createSurveyMutation({ name: 'New Survey', clientId: folder }).unwrap()
    if (survey) {
      navigate(`/surveys/${survey.data?.id}`)
    }
  }

  const handleDelete = async (id: number) => {
    setDeleteId(id)
    setPopupConfirm(true)
  }

  const acceptDelete = async () => {
    if (!deleteId) return
    await deleteSurveyMutation(deleteId)
    setPopupConfirm(false)
    setDeleteId(null)
  }

  const fetchSurveys = async () => {
    if (!folder) return
    trigger(`clientId=${folder}`)
  }

  useEffect(() => {
    fetchSurveys()
  }, [folder])

  return (
    <>
      <h1>
        {folder && <BackBtn onClick={() => setFolder(null)} />}
        Surveys
      </h1>
      {!folder ? (
        <ul className={style.folders + ' block'}>
          <li>
            <span>Client</span>
            <span>Active surveys</span>
            <span>Total surveys</span>
          </li>
          {clientsData?.map((client) => (
            <li key={client.id} onClick={() => setFolder(client.id as number)}>
              <span className={style.name}>
                <div className={style.img}>
                  <img src={client.logo} alt="logo" />
                </div>
                {client.name}
              </span>
              <span>{client.activeSurveys}</span>
              <span>{client.surveys.length}</span>
            </li>
          ))}
        </ul>
      ) : (
        <section className={style.surveys}>
          <div className="block">
            <div className={style.control}>
              <button className="btn" onClick={createSurvey}>
                + Add New
              </button>
            </div>
            <List columns={['Name of Client', 'Name of survey', 'Status', 'Number of responses', 'Date', '*']}>
              {surveys?.map((survey) => {
                return (
                  <li key={survey.id} className={style.survey_item}>
                    <div>
                      <img src={survey.client?.logo} alt="logo" />
                      {survey.client?.name}
                    </div>
                    <div>
                      <Link to={survey.id.toString()}>{survey.name}</Link>
                    </div>
                    <div>
                      <span className={survey.status.toLowerCase()}>{survey.status.toLowerCase()}</span>
                    </div>
                    <div>{survey._count?.userAnswers}</div>
                    <div>{new Date(survey.createdAt || '').toLocaleDateString()}</div>
                    <div>
                      <MoreActionsList>
                        <li onClick={() => handleDelete(survey.id)}>
                          <DeleteOutlineOutlined />
                          Delete
                        </li>
                        <li></li>
                      </MoreActionsList>
                    </div>
                  </li>
                )
              })}
            </List>
          </div>
          {popupConfirm && <FinalAccept title="Are you sure?" closePopup={() => setPopupConfirm(false)} accept={acceptDelete} />}
        </section>
      )}
    </>
  )
}

export default Surveys
